import type { Member } from '@shared/api.interface';

/** 每日上限为 0 表示不限次数，显示“不限”而不是“0” */
export function formatDailyLimit(dailyLimit: number): string {
  return dailyLimit > 0 ? String(dailyLimit) : '不限';
}

/** 会员类型下方的说明：次卡写总次数，年卡写每周期额度 */
export function formatTypeHint(member: Pick<Member, 'quota_mode' | 'total_quota' | 'monthly_quota'>): string {
  return member.quota_mode === 'total'
    ? `总次数 ${member.total_quota ?? 0}`
    : `按月配额 ${member.monthly_quota} 次`;
}

/** 有效期两行：主行“至 到期日”，辅行“开通日 开通 · N 个月”；未激活的码首次使用后才计算 */
export function formatValidity(
  member: Pick<Member, 'status' | 'start_date' | 'expiry_date'>,
  validityMonths?: number,
): { main: string; hint: string } {
  if (member.status === 'inactive') return { main: '未激活', hint: '首次使用后计算' };
  const parts = [member.start_date ? `${member.start_date} 开通` : '', validityMonths ? `${validityMonths} 个月` : '']
    .filter(Boolean);
  return { main: member.expiry_date ? `至 ${member.expiry_date}` : '-', hint: parts.join(' · ') };
}

/** 配额使用：次卡看累计/总次数，年卡看本周期已领/每周期额度（与原“配额使用”口径一致） */
export function quotaUsage(member: Pick<Member, 'quota_mode' | 'total_redemptions' | 'total_quota' | 'cycle_used' | 'monthly_quota'>): { used: number; limit: number } {
  return member.quota_mode === 'total'
    ? { used: member.total_redemptions, limit: member.total_quota ?? 0 }
    : { used: member.cycle_used, limit: member.monthly_quota };
}
